<template>
  <div class="eshop">
    <section class="container search-content">
      <SearchBar v-model="spuName" @search="toSearchResult"></SearchBar>
      <div class="shop-cart-box">
        <ShopCardIcon :value="basketCount" />
      </div>
    </section>
    <section class="container" v-if="activityList.length">
      <EshopTitle title="限时抢购" class="e-shop-title" titleEn="Flash Sale"></EshopTitle>
      <div class="activity-content">
        <div class="act-ctn">
          <GoodsPanel
            class="activity-item"
            v-for="item in activityList"
            :coverImage="item.coverImage"
            :price="item.salePrice"
            :oprice="item.oprice"
            :key="item.spuId"
            @handleTarget="handleActivityTarget(item.id, item.activityType==0?2:1)"
          >
            <div class="desc-content" v-if="item.activityType == 1">
              <div class="content-left">
                <img class="content-icon" src="@/assets/img/ms-icon.png" alt="" />
                <span>秒杀中</span>
              </div>
              <count-down :startTime="item.startStamp" :endTime="item.endStamp" :secondsTxt="''"></count-down>
            </div>
            <div class="desc-content" v-else>
              <div class="content-left">
                <img class="content-icon" src="@/assets/img/group-icon.png" alt="" />
                <span>{{ item.groupSize }}人团</span>
              </div>
            </div>
          </GoodsPanel>
        </div>
      </div>
      <div class="more-btn-content">
        <div class="more-btn" @click="toActivityList">
          更多
        </div>
      </div>
    </section>
    <section class="container">
      <img @click="toIntegralMall" src="@/assets/img/integratel-bg.png" class="integratel-bg" alt="">
    </section>
    <section class="container">
      <EshopTitle title="本周热销" class="e-shop-title" titleEn="Weekly Hot Sale"></EshopTitle>
      <HotSelling :goodsList="hotGoodsList" @handleTarget="(id) => handleTarget(id, 0)"></HotSelling>
    </section>
    <section class="container">
      <ChannelNav :list="groupList" :activeValue.sync="groupId" class="channel-nav-container"></ChannelNav>
      <TablePage ref="list" @page-change="pageHandler" :total="total" :pageSizeNum="3">
        <div class="good-list-container act-ctn">
          <GoodsPanel
            class="activity-item"
            v-for="item in goodsList"
            :coverImage="item.coverImage"
            :price="item.price"
            :oprice="item.oprice"
            :spuName="item.spuName"
            :spuNameEn="item.spuNameEn"
            :saleStartSwitch="item.saleStartSwitch"
            :saleAllow="item.saleAllow"
            :key="item.id"
            :id="item.id"
            @handleTarget="(id) => handleTarget(id, 0)"
          >
          </GoodsPanel>
        </div>
      </TablePage>
    </section>
  </div>
</template>

<script>
import GoodsPanel from "@/components/base/GoodsPanel";
import HotSelling from "./components/HotSelling.vue";
import ChannelNav from "@/components/base/Nav.vue";
import TablePage from "@/components/base/TablePage";
import SearchBar from "@/components/base/SearchBar";
import CountDown from "vue2-countdown";
import ShopCardIcon from "@/components/base/ShopCardIcon.vue";
import moment from "moment";
export default {
  name: "Eshop",
  components: { GoodsPanel, CountDown, HotSelling, ChannelNav, TablePage, SearchBar, ShopCardIcon },
  data() {
    return {
      activityList: [],
      hotGoodsList: [], //本周热销商品列表
      goodsList: [], //商品列表
      groupList: [], //渠道列表
      groupId: "",
      total: 0,
      spuName: "", //搜索关键词
      seatImage: require("@/assets/img/moren.png"),
      basketCount: 0,
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.getGoodsActivityList();
    this.getHotGoodsList();
    this.searchHandler();
    let groupList = await this.$optionsData.getGroupListOptions(); //获取渠道
    this.groupList = [{ label: "全部", value: "", labelEn: "All of it" }, ...groupList];
    this.getBasketCount();
  },
  methods: {
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    async getBasketCount() {
      try {
        let { data } = await this.$api.getBasketCount();
        this.basketCount = data || 0;
      } catch (error) {
        console.log(error);
      }
    },
    //跳转
    handleTarget(id, type) {
      this.$router.push(`/e-shop/good-info?id=${id}&type=${type}`);
    },
    //跳转(活动)
    handleActivityTarget(id, type) {
      this.$router.push(`/e-shop/good-info?activityId=${id}&type=${type}`);
    },
    toSearchResult() {
      this.$router.push(`/e-shop/search-result?value=${this.spuName}`);
    },
    async getGoodsActivityList() {
      const params = {
        sceneMarketSwitch: 1,
        page: 1,
        pageSize: 3,
        orderCountSort: 0,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getGoodsActivityList(params);
        this.activityList = (list || []).map((item) => {
          item.endStamp = moment(item.endTime).valueOf();
          item.startStamp = moment(item.startTime).valueOf();
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    },
    //获取本周热销列表
    async getHotGoodsList() {
      const params = {
        sceneMarketSwitch: 1,
        page: 1,
        pageSize: 5,
        orderCountSort: 0,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getGoodsList(params);
        list.length = 5;
        for (let i = 0; i < list.length; i++) {
          if (!list[i]) list[i] = {};
          list[i].coverImage = list[i].coverImage ? list[i].coverImage : this.seatImage;
        }
        this.hotGoodsList = list;
        this.$forceUpdate();
      } catch (error) {
        console.log(error);
      }
    },
    //获取商品列表
    async pageHandler(page, pageSize) {
      const params = {
        sceneMarketSwitch: 1,
        page: page,
        pageSize: pageSize,
        groupId: this.groupId,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getGoodsList(params);
        list = (list || []).slice(0, 5);
        this.goodsList = list.map((item) => {
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
    //跳转到活动列表
    async toActivityList() {
      this.$router.push(`/e-shop/act-list`);
    },
    toIntegralMall() {
      this.$router.push(`/integral-mall`);
    },
  },
  watch: {
    groupId(val) {
      this.searchHandler();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-content {
  margin-top: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.e-shop-title {
  margin: 80px 0 59px;
}
.act-ctn {
  display: flex;
  flex-wrap: wrap;
}
.activity-item {
  margin-right: 30px;
  margin-bottom: 30px;
  width: 380px;
  &.activity-item:nth-child(3n) {
    margin-right: 0;
  }
  .desc-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content-left {
      font-size: 16px;
      font-weight: 400;
      display: flex;
      align-items: center;
    }
    .content-icon {
      width: 21px;
      height: 21px;
      margin-right: 11px;
    }
  }
}
.channel-nav-container {
  margin-bottom: 60px;
  margin-top: 160px;
}
.good-list-container {
  display: flex;
  flex-wrap: wrap;
}
.more-btn-content .more-btn {
  width: 80px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #999999;
  line-height: 30px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}
.integratel-bg{
  margin-top: 20px;
}
</style>
